import React from 'react';
import styles from './Insurance.module.css';
import backgroundImage from '../../Images/I71.png'; // Import from images folder
import Thealth2 from '../../Images/T6.png';
import icon12 from '../../Images/icon12.png';
import icon15 from '../../Images/icon15.png';
import icon16 from '../../Images/icon16.png';

import iconT44 from '../../Images/icon45.png'; 
import iconT45 from '../../Images/icon46.png'; 
import iconT46 from '../../Images/icon47.png'; 
import iconT47 from '../../Images/icon48.png'; 
import iconT48 from '../../Images/icon50.png'; 

import Icon71 from '../../Images/icon81.png';
import icon72 from '../../Images/icon82.png';
import icon73 from '../../Images/icon87.png';
import icon74 from '../../Images/icon88.png';
import icon75 from '../../Images/icon89.png';
import icon76 from '../../Images/icon90.png';

import Ibg71 from '../../Images/Ibg71.png';


import iconT76 from '../../Images/iconT71.png';
import iconT77 from '../../Images/iconT72.png';
import iconT78 from '../../Images/iconT73.png';


import T56 from '../../Images/T60.png'; 
import T57 from '../../Images/T57.png';
import T58 from '../../Images/T61.png';
import T59 from '../../Images/T59.png';

import T66 from '../../Images/T66.png';
import T67 from '../../Images/T67.png';

import iconT49 from '../../Images/icon77.png'; 

import icon1 from '../../Images/icon1.png';
import icon2 from '../../Images/icon2.png';
import icon3 from '../../Images/icon3.png';
import icon4 from '../../Images/icon4.png';
import bT1 from '../../Images/I73.png';
import bT2 from '../../Images/I74.png';
import bT3 from '../../Images/I75.png';

// import bg1 from '../../Images/bg1.png';
// import cd1 from '../../Images/cd1.png';
// import cd2 from '../../Images/cd2.png';
// import cd3 from '../../Images/cd3.png';
// import cd4 from '../../Images/cd4.png';
// import sicon1 from '../../Images/sicon1.png';


const Insurance = () => {
  const handleCTAClick = (action) => {
    console.log(`${action} clicked`);
    // Add your navigation/modal logic here
  };

  return (
     <div className={styles.container71}>
  {/* Hero Section */}
  <section className={styles.heroSection71}>
    <div className={styles.heroContent71}>
      {/* Top label */}
      <div className={styles.heroLabel71}>
        <span className={styles.labelText71}>♻ AI-Powered Insurance Solutions</span>
      </div>

      {/* Main headline */}
      <h1 className={styles.heroHeadline71}>
        Transform Insurance with Intelligent AI
      </h1>

      {/* Subtext */}
      <p className={styles.heroSubtext71}>
        Automate claims processing, enhance customer experiences, and<br /> 
        detect fraud with cutting-edge AI technology designed specifically<br /> for insurance providers.
      </p>

      {/* CTA Buttons */}
      <div className={styles.ctaButtons71}>
        <button
          className={`${styles.ctaButton71} ${styles.ctaPrimary71}`}
          onClick={() => handleCTAClick('Request a Demo')}
        >
          Request a Demo →
        </button>
        <button
          className={`${styles.ctaButton71} ${styles.ctaSecondary71}`}
          onClick={() => handleCTAClick('Learn More')}
        >
          Learn More
        </button>
      </div>

      {/* Stats Section */}
      <div className={styles.statsSection71}>
        <div className={styles.statItem71}>
          <img src={icon12} alt="Speed Icon" className={styles.statIcon71} />
          <div className={styles.statValue71}>80%</div>
          <div className={styles.statLabel71}>Faster Claims</div>
        </div>

        <div className={styles.statItem71}>
          <img src={icon15} alt="Satisfaction Icon" className={styles.statIcon71} />
          <div className={styles.statValue71}>95%</div>
          <div className={styles.statLabel71}>Accuracy Rate</div>
        </div>

        <div className={styles.statItem71}>
          <img src={icon16} alt="Support Icon" className={styles.statIcon71} />
          <div className={styles.statValue71}>$2M+</div>
          <div className={styles.statLabel71}>Fraud Prevented</div>
        </div>
      </div>
    </div>

    {/* Background Image Container */}
    <div className={styles.heroBackground71}>
      <div
        className={styles.backgroundImage71}
        style={{
          backgroundImage: `url(${backgroundImage})`,
        }}
      />
    </div>
  </section>











{/* Why Choose ToxboxAI for Insurance? */}
<section className={styles.section72}>
  <div className={styles.container72}>
    {/* Header Section */}
    <div className={styles.headerSection72}>
      <h1 className={styles.title72}>
        Why Choose ToxboxAI for Insurance?
        {/* <span className={styles.highlight44}>Retail</span> */}
      </h1>
      <p className={styles.subtitle44}>
        Transform your insurance operations with AI-powered solutions that deliver measurable results
      </p> 
    </div>
  
    {/* Capabilities Grid */}
    <div className={styles.capabilitiesGrid72}>
      {/* Card 1 */}
      <div className={styles.capabilityCard72}>
        <div className={styles.cardHeader72}>
          <div className={styles.cardIcon72}>
            <img 
              src={iconT44}
              alt="Customer Service Icon" 
              className={styles.iconImage72}
            />
          </div>
          <h3 className={styles.cardTitle72}>
Automated Claims Processing</h3>
        </div>
        <p className={styles.cardDescription72}>
          Process claims 80% faster with AI-powered document analysis and intelligent automation.
        </p>
      </div>

      {/* Card 2 */}
      <div className={styles.capabilityCard72}>
        <div className={styles.cardHeader72}>
          <div className={styles.cardIcon72}>
            <img 
              src={iconT45} 
              alt="Customer Service Icon" 
              className={styles.iconImage72}
            />
          </div>
          <h3 className={styles.cardTitle72}>
Real-Time Risk Assessment</h3>
        </div>
        <p className={styles.cardDescription72}>
          Make informed underwriting decisions with instant risk analysis and predictive modeling.
        </p>
      </div>

      {/* Card 3 */}
      <div className={styles.capabilityCard72}>
        <div className={styles.cardHeader72}>
          <div className={styles.cardIcon72}>
            <img 
              src={iconT46} 
              alt="Customer Service Icon" 
              className={styles.iconImage72}
            />
          </div>
          <h3 className={styles.cardTitle72}>
Fraud Detection</h3>
        </div>
        <p className={styles.cardDescription72}>
          Identify fraudulent claims with 95% accuracy using advanced machine learning algorithms.
        </p>
      </div>

      {/* Card 4 */}
      <div className={styles.capabilityCard72}>
        <div className={styles.cardHeader72}>
          <div className={styles.cardIcon72}>
            <img 
              src={iconT47} 
              alt="Customer Service Icon" 
              className={styles.iconImage72}
            />
          </div>
          <h3 className={styles.cardTitle72}>
Cost Reduction</h3>
        </div>
        <p className={styles.cardDescription72}>
          Reduce operational costs by up to 40% through intelligent process automation.
        </p>
      </div>

      

      
    </div>
  </div>
</section>















{/*Intelligent Claims Processing 73*/}
<section className={styles.section73}>
  <div className={styles.container73}>


{/* New Header Section - AI-Powered Insurance Solutions */}
    <div className={styles.insuranceHeader73}>
      <h1 className={styles.insuranceTitle73}>AI-Powered Insurance Solutions</h1>
      <p className={styles.insuranceSubtitle73}>
        Discover how ToxboxAI transforms every aspect of your insurance operations
      </p>
    </div>


    <div className={styles.contentWrapper73}>
      {/* Left side - Text Content */}
      <div className={styles.textContent73}>
        <div className={styles.textHeader73}>
          <h2 className={styles.sectionTitle73}>Intelligent Claims Processing</h2>
          <p className={styles.sectionSubtitle73}>
            Streamline your claims workflow with AI-powered automation
          </p>
        </div>
        
        <div className={styles.featuresList73}>
          <div className={styles.featureItem73}>
            <div className={styles.featureIconWrapper73}>
              {/* You can replace this with an actual icon component or SVG */}
              <div className={styles.iconCircle73}>
                <span className={styles.iconText73}>✓</span>
              </div>
            </div>
            <div className={styles.featureText73}>
              {/* <h3 className={styles.featureTitle73}>Real-time booking updates</h3> */}
              <p className={styles.featureDescription73}>
                Automated document extraction and validation
              </p>
            </div>
          </div>
          
          <div className={styles.featureItem73}>
            <div className={styles.featureIconWrapper73}>
              <div className={styles.iconCircle73}>
                <span className={styles.iconText73}>✓</span>
              </div>
            </div>
            <div className={styles.featureText73}>
              {/* <h3 className={styles.featureTitle73}>Automated cancellations and refunds</h3> */}
              <p className={styles.featureDescription73}>
                Instant damage assessment using computer vision
              </p>
            </div>
          </div>
          
          <div className={styles.featureItem73}>
            <div className={styles.featureIconWrapper73}>
              <div className={styles.iconCircle73}>
                <span className={styles.iconText73}>✓</span>
              </div>
            </div>
            <div className={styles.featureText73}>
              {/* <h3 className={styles.featureTitle73}>Multi-platform integration</h3> */}
              <p className={styles.featureDescription73}>
                Smart claim routing and prioritization
              </p>
            </div>
            
          </div>



            <div className={styles.featureItem73}>
            <div className={styles.featureIconWrapper73}>
              <div className={styles.iconCircle73}>
                <span className={styles.iconText73}>✓</span>
              </div>
            </div>
            <div className={styles.featureText73}>
              {/* <h3 className={styles.featureTitle73}>Multi-platform integration</h3> */}
              <p className={styles.featureDescription73}>
                Real-time claim status updates
              </p>
            </div>
            
          </div>



        </div>
        
        {/* <button className={styles.primaryButton73}>
          <span>Automate Bookings</span>
          <span className={styles.buttonArrow73}>→</span>
        </button> */}
      </div>
      
      {/* Right side - Image/Visual */}
      <div className={styles.imageContainer73}>
        <div className={styles.imageWrapper73}>
          {/* Main dashboard image */}
          <div className={styles.mainImageContainer73}>
            <img 
              src={bT1} 
              alt="Booking Dashboard Interface"
              className={styles.heroImage73}
            />
          </div>

      
          
          </div>
      </div>
    </div>
  </div>
</section>













{/* Advanced Fraud Detection 74 */}
<section className={styles.section74}>
  <div className={styles.container74}>
    <div className={styles.contentWrapper74}>
      {/* Left side - Image/Visual */}
      <div className={styles.imageContainer74}>
        <div className={styles.imageWrapper74}>
          <div className={styles.mainImageContainer74}>
            <img 
              src={bT2} 
              alt="Travel Recommendations Dashboard"
              className={styles.heroImage74}
            />
          </div>
        </div>
      </div>
      
      {/* Right side - Text Content */}
      <div className={styles.textContent74}>
        <div className={styles.textHeader74}>
          <h2 className={styles.sectionTitle74}>Advanced Fraud Detection</h2>
          <p className={styles.sectionSubtitle74}>
            Protect your business with AI-powered fraud prevention
          </p>
        </div>
        
        <div className={styles.featuresList74}>
          <div className={styles.featureItem74}>
            <div className={styles.featureIconWrapper74}>
              <div className={styles.iconCircle74}>
                <span className={styles.iconText74}>✓</span>
              </div>
            </div>
            <div className={styles.featureText74}>
              {/* <h3 className={styles.featureTitle74}>Smart itinerary planning</h3> */}
              <p className={styles.featureDescription74}>
                Pattern recognition across historical claims data
              </p>
            </div>
          </div>
          
          <div className={styles.featureItem74}>
            <div className={styles.featureIconWrapper74}>
              <div className={styles.iconCircle74}>
                <span className={styles.iconText74}>✓</span>
              </div>
            </div>
            <div className={styles.featureText74}>
              {/* <h3 className={styles.featureTitle74}>Personalized package recommendations</h3> */}
              <p className={styles.featureDescription74}>
                Real-time anomaly detection
              </p>
            </div>
          </div>
          
          <div className={styles.featureItem74}>
            <div className={styles.featureIconWrapper74}>
              <div className={styles.iconCircle74}>
                <span className={styles.iconText74}>✓</span>
              </div>
            </div>
            <div className={styles.featureText74}>
              {/* <h3 className={styles.featureTitle74}>Upsell & cross-sell opportunities</h3> */}
              <p className={styles.featureDescription74}>
                Network analysis to identify fraud rings
              </p>
            </div>
          </div>



            <div className={styles.featureItem74}>
            <div className={styles.featureIconWrapper74}>
              <div className={styles.iconCircle74}>
                <span className={styles.iconText74}>✓</span>
              </div>
            </div>
            <div className={styles.featureText74}>
              {/* <h3 className={styles.featureTitle74}>Upsell & cross-sell opportunities</h3> */}
              <p className={styles.featureDescription74}>
                Continuous learning from new fraud patterns
              </p>
            </div>
          </div>




        </div>
        
        {/* <button className={styles.primaryButton74}>
          <span>Enhance Guest Experience</span>
          <span className={styles.buttonArrow74}>→</span>
        </button> */}
      </div>
    </div>
  </div>
</section>
















{/* Personalized Customer Service 75 */}
<section className={styles.section75}>
  <div className={styles.container75}>
    <div className={styles.contentWrapper75}>
      {/* Left side - Text Content */}
      <div className={styles.textContent75}>
        <div className={styles.textHeader75}>
          <h2 className={styles.sectionTitle75}>Personalized Customer Service</h2>
          <p className={styles.sectionSubtitle75}>
            Deliver exceptional experiences with AI-powered support
          </p>
        </div>
        
        <div className={styles.featuresList75}>
          <div className={styles.featureItem75}>
            <div className={styles.featureIconWrapper75}>
              <div className={styles.iconCircle75}>
                <span className={styles.iconText75}>✓</span>
              </div>
            </div>
            <div className={styles.featureText75}>
              {/* <h3 className={styles.featureTitle75}>Instant responses across channels</h3> */}
              <p className={styles.featureDescription75}>
                24/7 AI chatbot for instant support
              </p>
            </div>
          </div>
          
          <div className={styles.featureItem75}>
            <div className={styles.featureIconWrapper75}>
              <div className={styles.iconCircle75}>
                <span className={styles.iconText75}>✓</span>
              </div>
            </div>
            <div className={styles.featureText75}>
              {/* <h3 className={styles.featureTitle75}>Multilingual support</h3> */}
              <p className={styles.featureDescription75}>
                Personalized policy recommendations
              </p>
            </div>
          </div>
          
          <div className={styles.featureItem75}>
            <div className={styles.featureIconWrapper75}>
              <div className={styles.iconCircle75}>
                <span className={styles.iconText75}>✓</span>
              </div>
            </div>
            <div className={styles.featureText75}>
              {/* <h3 className={styles.featureTitle75}>AI handling FAQs and complex queries</h3> */}
              <p className={styles.featureDescription75}>
                Proactive customer engagement
              </p>
            </div>
          </div>



            <div className={styles.featureItem75}>
            <div className={styles.featureIconWrapper75}>
              <div className={styles.iconCircle75}>
                <span className={styles.iconText75}>✓</span>
              </div>
            </div>
            <div className={styles.featureText75}>
              {/* <h3 className={styles.featureTitle75}>AI handling FAQs and complex queries</h3> */}
              <p className={styles.featureDescription75}>
                Multi-language support
              </p>
            </div>
          </div>



        </div>
        
        {/* <button className={styles.primaryButton75}>
          <span>Deploy AI Assistant</span>
          <span className={styles.buttonArrow75}>→</span>
        </button> */}
      </div>
      
      {/* Right side - Image/Visual */}
      <div className={styles.imageContainer75}>
        <div className={styles.imageWrapper75}>
          <div className={styles.mainImageContainer75}>
            <img 
              src={bT3} 
              alt="AI Assistant Chat Interface"
              className={styles.heroImage75}
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</section>





  


{/* Comprehensive AI Features 75 */}
<section className={styles.Comprehense75}>
  <div className={styles.container75}>
    {/* Header Section */}
    <div className={styles.header75}>
      <h1 className={styles.title75}>Comprehensive AI Features</h1>
      <p className={styles.subtitle75}>
        Everything you need to modernize your insurance operations in one powerful platform
      </p>
    </div>

    {/* 6 Feature Cards Grid */}
    <div className={styles.cardsGrid75}>
      {/* Card 1: Smart Underwriting */}
      <div className={styles.card75}>
        <div className={styles.cardIcon75}>
          <img 
            src={Icon71} 
            alt="Smart Underwriting"
            className={styles.iconImage75}
          />
        </div>
        <h3 className={styles.cardTitle75}>Smart Underwriting</h3>
        <p className={styles.cardDescription75}>
          AI-powered risk assessment for accurate policy pricing
        </p>
      </div>

      {/* Card 2: Fraud Prevention */}
      <div className={styles.card75}>
        <div className={styles.cardIcon75}>
          <img 
            src={icon72} 
            alt="Fraud Prevention"
            className={styles.iconImage75}
          />
        </div>
        <h3 className={styles.cardTitle75}>Fraud Prevention</h3>
        <p className={styles.cardDescription75}>
          Advanced detection algorithms to minimize losses
        </p>
      </div>

      {/* Card 3: Instant Processing */}
      <div className={styles.card75}>
        <div className={styles.cardIcon75}>
          <img 
            src={icon73} 
            alt="Instant Processing"
            className={styles.iconImage75}
          />
        </div>
        <h3 className={styles.cardTitle75}>Instant Processing</h3>
        <p className={styles.cardDescription75}>
          Automate workflows for lightning-fast operations
        </p>
      </div>

      {/* Card 4: Customer Insights */}
      <div className={styles.card75}>
        <div className={styles.cardIcon75}>
          <img 
            src={icon74} 
            alt="Customer Insights"
            className={styles.iconImage75}
          />
        </div>
        <h3 className={styles.cardTitle75}>Customer Insights</h3>
        <p className={styles.cardDescription75}>
          Deep analytics to understand policyholder behavior
        </p>
      </div>

      {/* Card 5: Predictive Analytics */}
      <div className={styles.card75}>
        <div className={styles.cardIcon75}>
          <img 
            src={icon75} 
            alt="Predictive Analytics"
            className={styles.iconImage75}
          />
        </div>
        <h3 className={styles.cardTitle75}>Predictive Analytics</h3>
        <p className={styles.cardDescription75}>
          Forecast trends and optimize business strategies
        </p>
      </div>

      {/* Card 6: 24/7 Availability */}
      <div className={styles.card75}>
        <div className={styles.cardIcon75}>
          <img 
            src={icon76} 
            alt="24/7 Availability"
            className={styles.iconImage75}
          />
        </div>
        <h3 className={styles.cardTitle75}>24/7 Availability</h3>
        <p className={styles.cardDescription75}>
          Always-on AI support for customers and agents
        </p>
      </div>
    </div>

    {/* Bottom Section with Image */}
    <div className={styles.bottomSection75}>
      <div className={styles.bottomContent75}>
        <div className={styles.bottomText75}>
          <h2 className={styles.bottomTitle75}>Advanced Risk Assessment</h2>
          <p className={styles.bottomDescription75}>
            Leverage machine learning to evaluate risks with unprecedented accuracy. 
            Our AI analyzes thousands of data points to provide comprehensive risk profiles in seconds.
          </p>
          
          <ul className={styles.featuresList75}>
            <li className={styles.featureItem75}>
              <span className={styles.checkmark75}>✓</span>
              Real-time risk scoring
            </li>
            <li className={styles.featureItem75}>
              <span className={styles.checkmark75}>✓</span>
              Historical data analysis
            </li>
            <li className={styles.featureItem75}>
              <span className={styles.checkmark75}>✓</span>
              Market trend integration
            </li>
            <li className={styles.featureItem75}>
              <span className={styles.checkmark75}>✓</span>
              Customizable risk parameters
            </li>
          </ul>

          <button className={styles.learnMoreButton75}>
            Learn More
          </button>
        </div>

        <div className={styles.bottomImageContainer75}>
          <img 
            src={Ibg71} 
            alt="Advanced Risk Assessment Dashboard"
            className={styles.bottomImage75}
          />
        </div>
      </div>
    </div>
  </div>
</section>













<section className={styles.Leader76}>
  <div className={styles.container76}>
    {/* Header Section */}
    <div className={styles.header76}>
      <h2 className={styles.title76}>Trusted by Industry Leaders</h2>
      <p className={styles.subtitle76}>
        Join hundreds of insurance companies that have transformed their operations with ToxboxAI
      </p>
    </div>

    {/* Testimonial Cards */}
    <div className={styles.testimonialsGrid76}>
      {/* Card 1 */}
      <div className={styles.testimonialCard76}>
        <div className={styles.stars76}>
          <span className={styles.star76}>★</span>
          <span className={styles.star76}>★</span>
          <span className={styles.star76}>★</span>
          <span className={styles.star76}>★</span>
          <span className={styles.star76}>★</span>
        </div>
        
        <p className={styles.quote76}>
          "ToxboxAI has revolutionized our claims processing. We've reduced processing time by 75% and our customers are happier than ever."
        </p>
        
        <div className={styles.profile76}>
          <div className={styles.profileImageContainer76}>
            <img 
              src={iconT76}
              alt="Sarah Johnson"
              className={styles.profileImage76}
            />
          </div>
          <div className={styles.profileInfo76}>
            <h4 className={styles.profileName76}>Sarah Johnson</h4>
            <p className={styles.profileTitle76}>VP of Operations</p>
            <p className={styles.profileCompany76}>Global Insurance Partners</p>
          </div>
        </div>
      </div>

      {/* Card 2 */}
      <div className={styles.testimonialCard76}>
        <div className={styles.stars76}>
          <span className={styles.star76}>★</span>
          <span className={styles.star76}>★</span>
          <span className={styles.star76}>★</span>
          <span className={styles.star76}>★</span>
          <span className={styles.star76}>★</span>
        </div>
        {/* <div className={styles.statsBadge76}>
          <span className={styles.statNumber76}>99%</span>
        </div> */}
        
        <p className={styles.quote76}>
          "The fraud detection capabilities are outstanding. We've prevented millions in fraudulent claims and the ROI has been exceptional."
        </p>
        
        <div className={styles.profile76}>
          <div className={styles.profileImageContainer76}>
            <img 
              src={iconT77} 
              alt="Michael Chen"
              className={styles.profileImage76}
            />
          </div>
          <div className={styles.profileInfo76}>
            <h4 className={styles.profileName76}>Michael Chen</h4>
            <p className={styles.profileTitle76}>Chief Technology Officer</p>
            <p className={styles.profileCompany76}>SecureLife Insurance</p>
          </div>
        </div>
      </div>

      {/* Card 3 */}
      <div className={styles.testimonialCard76}>
        <div className={styles.stars76}>
          <span className={styles.star76}>★</span>
          <span className={styles.star76}>★</span>
          <span className={styles.star76}>★</span>
          <span className={styles.star76}>★</span>
          <span className={styles.star76}>★</span>
        </div>
        {/* <div className={styles.statsBadge76}>
          <span className={styles.statNumber76}>99%</span>
        </div> */}
        
        <p className={styles.quote76}>
          "Customer satisfaction scores have increased by 40% since implementing ToxboxAI. The AI chatbot handles inquiries brilliantly."
        </p>
        
        <div className={styles.profile76}>
          <div className={styles.profileImageContainer76}>
            <img 
              src={iconT78} 
              alt="Emily Rodriguez"
              className={styles.profileImage76}
            />
          </div>
          <div className={styles.profileInfo76}>
            <h4 className={styles.profileName76}>Emily Rodriguez</h4>
            <p className={styles.profileTitle76}>Director of Customer Experience</p>
            <p className={styles.profileCompany76}>HealthGuard Insurance</p>
          </div>
        </div>
      </div>
    </div>

    {/* Stats Section */}
    <div className={styles.statsSection76}>
      <div className={styles.statsGrid76}>
        <div className={styles.statItem76}>
          <div className={styles.statNumberLarge76}>500+</div>
          <div className={styles.statLabel76}>Insurance Companies</div>
        </div>
        
        <div className={styles.statItem76}>
          <div className={styles.statNumberLarge76}>10M+</div>
          <div className={styles.statLabel76}>Claims Processed</div>
        </div>
        
        <div className={styles.statItem76}>
          <div className={styles.statNumberLarge76}>95%</div>
          <div className={styles.statLabel76}>Customer Satisfaction</div>
        </div>
        
        <div className={styles.statItem76}>
          <div className={styles.statNumberLarge76}>$100M+</div>
          <div className={styles.statLabel76}>Fraud Prevented</div>
        </div>
      </div>
    </div>
  </div>
</section>













<section className={styles.Leader77}>
  <div className={styles.container77}>
    {/* Main Heading */}
    <div className={styles.heading77}>
      <h1 className={styles.title77}>
        Ready to Transform Your Insurance Operations?
      </h1>
    </div>

    {/* Description Text */}
    <div className={styles.description77}>
      <p className={styles.descriptionText77}>
        Join hundreds of insurance companies that have modernized their operations with ToxboxAI. 
        Get started today and see results in weeks, not months.
      </p>
    </div>

    {/* Action Buttons */}
    <div className={styles.buttons77}> 
      <button className={`${styles.button77} ${styles.primaryButton77}`}>
        📅 Schedule a Demo →
      </button>
      <button className={`${styles.button77} ${styles.secondaryButton77}`}>
        🗨 Talk to Sales ➙
      </button>
    </div>

    {/* Trust Badge */}
    <div className={styles.trustSection77}>
      <p className={styles.trustText77}>
        Trusted by leading insurance providers worldwide
      </p>
    </div>

    {/* Company Logos */}
    <div className={styles.companies77}>
      <div className={styles.companiesGrid77}>
        <div className={styles.companyLogo77}>
          {/* <img 
            src="/logos/global-insurance-partners.png" 
            alt="Global Insurance Partners"
            className={styles.logoImage77}
          /> */}
          <span className={styles.companyName77}>Global Insurance Partners</span>
        </div>
        
        <div className={styles.companyLogo77}>
          {/* <img 
            src="/logos/securelife-insurance.png" 
            alt="SecureLife Insurance"
            className={styles.logoImage77}
          /> */}
          <span className={styles.companyName77}>SecureLife Insurance</span>
        </div>
        
        <div className={styles.companyLogo77}>
          {/* <img 
            src="/logos/healthguard-insurance.png" 
            alt="HealthGuard Insurance"
            className={styles.logoImage77}
          /> */}
          <span className={styles.companyName77}>HealthGuard Insurance</span>
        </div>
      </div>
    </div>
  </div>
</section>










      
    </div>
  );
};

export default Insurance;
